import { KeyboardEvent, useState } from 'react';

import { searchCustomer } from 'src/apis/customerApi';
import { SearchCodeModalForm } from 'src/components/common/form/search/SearchCodeModalForm';
import { SearchDateSingleForm } from 'src/components/common/form/search/SearchDateSingleForm';
import { SearchDropDownForm } from 'src/components/common/form/search/SearchDropDownForm';
import { SearchSectionForm } from 'src/components/common/form/search/SearchSectionForm';
import { SysCodeDto } from 'src/dtos/code/sysCodeDto';
import { useInfoFormEvents } from 'src/hooks/useInfoFormEvents';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import useUiuxStore from 'src/store/useUiuxStore';
import { InfoCodeSearchFieldConfig } from 'src/types/info-form';

import { defaultTQC1050_R01Filter, useTQC1050_R01Store } from './Store_TQC1050_R01';

interface Props {
	onEnterKeyDown: () => void;
}

const INOUT_CLASS_TARGETS = ['110', '170'];

/** 사업장 / 입고일자 / 입고구분 / 거래처 / 브랜드 조회조건 영역. */
export const SearchSection_TQC1050_R01 = ({ onEnterKeyDown }: Props) => {
	const { TQC1050_R01Filter, setTQC1050_R01Filter } = useTQC1050_R01Store();
	const { compCdList, brandCdList, inoutClassList } = useCommonCodeStore();
	const { setCodeSearchModalProps } = useUiuxStore();

	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

	const handleCustFoucsId = 'tqc1050_customCd_search';
	const inoutClassOptions = inoutClassList.filter((code) =>
		INOUT_CLASS_TARGETS.includes(code.minorCd)
	);

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: handleCustFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find((value) => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: TQC1050_R01Filter.customCd || '',
				customNm: TQC1050_R01Filter.customNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: TQC1050_R01Filter,
		setEditData: setTQC1050_R01Filter,
		defaultData: defaultTQC1050_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'TQC1050_R01_search',
	});

	const handleCustomKeyDown = async (e: KeyboardEvent<HTMLInputElement>) => {
		getFieldHandlers('customCd').onEnterKeyDown(e);
		if (e.key === 'Enter') {
			onEnterKeyDown();
		}
	};

	return (
		<SearchSectionForm>
			<SearchDropDownForm
				label="사업장"
				value={TQC1050_R01Filter.compCd}
				optionList={compCdList}
				onChangeItem={(selectedItem) =>
					setTQC1050_R01Filter({ compCd: selectedItem?.compCd || '' })
				}
			/>

			<SearchDateSingleForm
				label="입고일자"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				value={TQC1050_R01Filter.transportDt}
				onChange={(date) => setTQC1050_R01Filter({ transportDt: date })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>

			<SearchDropDownForm<SysCodeDto>
				label="입고구분"
				value={TQC1050_R01Filter.inoutClass}
				optionList={inoutClassOptions}
				onChangeItem={(selectedItem) =>
					setTQC1050_R01Filter({ inoutClass: selectedItem?.minorCd || '' })
				}
			/>

			<SearchCodeModalForm
				label="거래처"
				value={TQC1050_R01Filter.customCd}
				valueLabel={TQC1050_R01Filter.customNm}
				handleFoucsId={handleCustFoucsId}
				onChange={getFieldHandlers('customCd').onChange}
				onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
				onKeyDown={handleCustomKeyDown}
			/>

			<SearchDropDownForm<SysCodeDto>
				label="브랜드"
				value={TQC1050_R01Filter.brandCd}
				optionList={brandCdList}
				onChangeItem={(selectedItem) =>
					setTQC1050_R01Filter({ brandCd: selectedItem?.minorCd || '' })
				}
			/>
		</SearchSectionForm>
	);
};
